class CheckDeprecatedAv {
    constructor(element) {
        this.container = element;
        this.avSelectInput = this.container.querySelector("[data-select-av]");
        this.avTotaalWarning = this.container.querySelector(
            "[data-show-deprecated-warning-av-totaal]"
        );
        this.avCumlaudeWarning = this.container.querySelector(
            "[data-show-deprecated-warning-av-cum-laude]"
        );
        this.avTotaalValue = "AV004-AVZ04";
        this.avCumlaudeValue = "AV076-AZ076";

        this.init();
    }

    init() {
        if (!this.avSelectInput) return;

        this.checkSelectedAv();
        this.assignListeners();
    }

    assignListeners() {
        this.avSelectInput.addEventListener(
            "change",
            this.checkSelectedAv.bind(this)
        );

        this.avSelectInput.addEventListener(
            "ZZ_share_dentist_change",
            this.checkSelectedAv.bind(this)
        );
    }

    checkSelectedAv(input = false) {
        const avSelectInput = input.target || this.avSelectInput;
        const avSelectValue = avSelectInput.value;

        avSelectValue && this.toggleDeprecatedWarning(avSelectValue);
    }

    toggleDeprecatedWarning(selectedAv) {
        if (this.avTotaalWarning) {
            selectedAv === this.avTotaalValue
                ? this.avTotaalWarning.classList.add("is-hidden")
                : this.avTotaalWarning.classList.remove("is-hidden");
        }

        if (this.avCumlaudeWarning) {
            selectedAv === this.avCumlaudeValue
                ? this.avCumlaudeWarning.classList.add("is-hidden")
                : this.avCumlaudeWarning.classList.remove("is-hidden");
        }
    }
}
